module.exports = __webpack_public_path__ + "static/media/empty-state-damage-maps.6076488c.svg";